export const survivalPlotClassName = 'survival-plot';
